<script>
  import {
    Modal,
    DataTable,
    Search,
    ToastNotification,
  } from "carbon-components-svelte";
  import ConfirmModal from "./ConfirmModal.svelte";
  import BaseModal from "./BaseModal.svelte";
  import { openAlertModal } from "../utils/AlertHelper.js";

  import { createEventDispatcher } from "svelte";
  import AlertModal from "./AlertModal.svelte";

  const dispatch = createEventDispatcher();
  export let open;
  export let macros;
  let searchText = "";
  let selectedDoc;
  let confirmOpen = false;
  let confirmObj;

  const headers = [
    { key: "사용자코드", value: "사용자코드" },
    { key: "plain_text", value: "상용구" },
  ];

  let selectedRowIds = [];
  $: filteredList = macros.filter(
    (macro) =>
      macro.plain_text.includes(searchText) ||
      macro.사용자코드.includes(searchText)
  );

  function submit() {
    const selectedItems = selectedRowIds.map((i) => macros[i]);
    if (selectedItems.length === 0) {
      openAlertModal({
        width: 400,
        title: "알림",
        content: "선택된 항목이 없습니다.",
        submit: function (event) {
        },
      });
      return;
    }
    selectedRowIds = [];
    dispatch("submit", { items: selectedItems });
  }
</script>

<BaseModal
  bind:show={open}
  onClose={() => (open = false)}
  title="상용구 선택"
  width={493}
  disableOverlayClose={true}
  on:submit={submit}
>
  <style>
    .macro-modal > .bx--modal-container {
      width: 500px;
    }
  </style>
  <Search placeholder="검색어 입력..." bind:value={searchText} />
  <DataTable
    selectable
    sortable
    bind:selectedRowIds
    {headers}
    bind:rows={filteredList}
  />
</BaseModal>

<ConfirmModal bind:open={confirmOpen} {confirmObj} />
